import React from 'react';
import { CalendarIcon, ClockIcon, CheckCircleIcon } from 'lucide-react';
export const Visualization = () => {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-411">
      <div className="max-w-7xl mx-auto" data-id="element-412">
        <div className="text-center mb-12" data-id="element-413">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-414">
            Visualizá tu nueva rutina
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-415">
            Así será tu vida con el Recetario Fit para Airfryer
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-416">
          <div className="space-y-6 order-2 md:order-1" data-id="element-417">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-418">
              <div className="flex items-start gap-4" data-id="element-419">
                <div className="bg-teal-100 p-2 rounded-full mt-1" data-id="element-420">
                  <CalendarIcon className="h-5 w-5 text-teal-600" data-id="element-421" />
                </div>
                <div data-id="element-422">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-423">
                    Domingo de preparación
                  </h3>
                  <p className="text-gray-700" data-id="element-424">
                    Cocinás una hora. Y ya resolviste 12 comidas para la semana.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-425">
              <div className="flex items-start gap-4" data-id="element-426">
                <div className="bg-teal-100 p-2 rounded-full mt-1" data-id="element-427">
                  <ClockIcon className="h-5 w-5 text-teal-600" data-id="element-428" />
                </div>
                <div data-id="element-429">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-430">
                    Martes ocupado
                  </h3>
                  <p className="text-gray-700" data-id="element-431">
                    Llegás tarde. Y en 10 minutos... cena lista. Caliente.
                    Crocante. Fit. Rica.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-432">
              <div className="flex items-start gap-4" data-id="element-433">
                <div className="bg-teal-100 p-2 rounded-full mt-1" data-id="element-434">
                  <CheckCircleIcon className="h-5 w-5 text-teal-600" data-id="element-435" />
                </div>
                <div data-id="element-436">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-437">
                    Una semana después
                  </h3>
                  <p className="text-gray-700" data-id="element-438">
                    Bajaste el delivery. Volvieron las verduras. La balanza se
                    mueve sin sacrificio.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center order-1 md:order-2" data-id="element-439">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cJWrSCPxy1be1T3dhxaz2C/4ddf5091-612a-4739-9c15-df9098595047.png" alt="Persona feliz con comida saludable" className="rounded-lg shadow-xl w-full max-w-md" data-id="element-440" />
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-441">
          <p className="text-lg text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-442">
            "Ceno rico. Bajo calorías. Gasto menos."
            <br data-id="element-443" />
            Repetilo en tu mente. Porque es real.
          </p>
          <a href="https://vhwt09-gz.myshopify.com/checkouts/cn/hWN3ajyOi9gyqJJTJgcXUW4g/es-ar?cart_link_id=CISumiVv&preview_theme_id=133233049643" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 text-xl" data-id="element-444">
            Quiero todo hoy solo por $19.990
          </a>
        </div>
      </div>
    </section>;
};